import {useTranslation} from "react-i18next";

// 导出可复用的翻译钩子函数
export function useColumnLabel() {
  const {t} = useTranslation();

  // 核心翻译方法
  const getColumnLabel = (key: string) => {
    const translationMap: Record<string, string> = {
      employee_name: t("hr.employee.Person Name"),
      employee_code: t("hr.employee.Person ID"),
      att_date: t("common.Date"),
      timesheet_name: t("common.Timesheet"),
      clock_in: t("common.Clock In"),
      clock_out: t("common.Clock Out"),
      break_in: t("common.Break In"),
      break_out: t("common.Break Out"),
      period_hrs: t("common.Clock Time(h)"),
      paid_work_deduct_break: t("common.Total Work Time(h)"),
      overtime_hrs: t("common.Total Overtime Time(h)"),
      paid_work: t("common.Total Time(h)"),
      paid_break: t("common.Total Break Time(h)"),
      pairing: t("common.Statistic Rule Mode"),
      abnormal_situation: t("common.Abnormal Situation"),
      timesheet_names: t("common.Timesheet"),
      att_dates: t("common.Date"),
      total_late_in: t("common.total_late_in"),
      total_early_out: t("common.total_early_out"),
      total_break: t("common.Total_break"),
      total_paid_work_deduct_break: t("common.Total_paid_work"),
      total_overtime_hrs: t("common.Total_overtime"),
      total_paid_work: t("common.Total_work"),
      department_name: t("common.Department"),
      ot1_hrs: t("common.T1 OT Hours"),
      ot2_hrs: t("common.T2 OT Hours"),
      ot_ratio: t("common.OT Ratio"),
      risk_level: t("common.Risk Level"),
    };
    const match = key.match(/^(.+?)(\d+)$/);

    if (match) {
      const baseKey = match[1];
      const suffix = match[2];

      if (translationMap[baseKey]) {
        if (baseKey.includes('period_hrs')){
          return t("common.Clock Time Value(h)", {value: `${(parseInt(suffix) + 1).toString()}`})
        }
        return translationMap[baseKey] + " " + (parseInt(suffix) + 1).toString();
      }
    }

    return translationMap[key] || key;
  };

  return {getColumnLabel};
}
